<p>View Order Detail 
<span *ngIf="orderId"> for {{orderId}}</span>
</p>

